import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ORNavigationService {
  constructor() {}

  private navigationLoading = new BehaviorSubject<boolean>(true);
  public navigationLoading$ = this.navigationLoading.asObservable();

  private goHomeStream = new Subject<void>();
  public goHomeStream$ = this.goHomeStream.asObservable();

  private goBackStream = new Subject<void>();
  public goBackStream$ = this.goBackStream.asObservable();

  goHome() {
    this.goHomeStream.next();
  }

  goBack() {
    this.goBackStream.next();
  }

  public setNavigationLoading(navigationLoading: boolean): void {
    this.navigationLoading.next(navigationLoading);
  }
}
